module.exports = __webpack_public_path__ + "static/staw-krzeslo_thumb-147a767f013f739a901abb26aa987473.jpg";